import { FormGroup, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ScreenType } from '../models/enums.models';
import { Customer } from '../models/customer.model';
import { LookUps } from '../models/look-up.model';
import { HttpClient } from '@angular/common/http';
import { Claim } from '../models/claim.model';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class StateService {
    constructor(private http: HttpClient, private router: Router) { }

    enableSaving = false;
    lookUps?: LookUps;
    customer?: Customer;
    cachedClaim: string | null = null;
    cachedCustomer: string | null = null;

    private _formIsSubmittedSubject = new BehaviorSubject<boolean>(false);
    $formIsSubmitted = this._formIsSubmittedSubject.asObservable(); 

    private _isFirstSignInSubject = new BehaviorSubject<boolean>(false); 
    $isFirstSignIn = this._isFirstSignInSubject.asObservable();
   
    $formDisabled: Subject<boolean> = new Subject();
    $loginDisplay: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private _isSigningUpSubject = new BehaviorSubject<boolean>(this.getSigningUpFromStorage());
    $isSigningUp = this._isSigningUpSubject.asObservable();

    private _claimSubject = new BehaviorSubject<Claim | undefined>(undefined);
    $claim = this._claimSubject.asObservable();

    private _claimRefSubject = new BehaviorSubject<string | undefined>(undefined);
    $claimRef = this._claimRefSubject.asObservable();

    private _guidSubject = new BehaviorSubject<string | undefined>(undefined);
    $guid = this._guidSubject.asObservable();

    private _isInitialLoginSubject = new BehaviorSubject<boolean>(true);
    $isInitialLogin = this._isInitialLoginSubject.asObservable();

    private _formInvolvedAccidentSaved = new BehaviorSubject<boolean>(false);
    $formInvolvedAccidentSaved = this._formInvolvedAccidentSaved.asObservable(); 
   
    set isFirstSignIn(value: boolean) {
        this._isFirstSignInSubject.next(value);
    }

    get isFirstSignIn(): boolean {
        return this._isFirstSignInSubject.value;
    }

    set isSigningUp(value: boolean) {
        this._isSigningUpSubject.next(value);
        localStorage.setItem('isSigningUp', JSON.stringify(value)); 
    }

    get isSigningUp(): boolean {
        return this._isSigningUpSubject.value;
    }

    private getSigningUpFromStorage(): boolean {
        const storedValue = localStorage.getItem('isSigningUp');
        return storedValue ? JSON.parse(storedValue) : false;
    }

    set claim(value: Claim | undefined) {
        this._claimSubject.next(value);
    }

    get claim(): Claim | undefined {
        return this._claimSubject.value;
    }

    set claimRef(value: string | undefined) {
        this._claimRefSubject.next(value);
    }

    get claimRef(): string | undefined {
        return this._claimRefSubject.value;
    }

    set guid(value: string | undefined) {
        this._guidSubject.next(value);
    }

    get guid(): string | undefined {
        return this._guidSubject.value;
    }

    set isInitialLogin(value: boolean) {
        this._isInitialLoginSubject.next(value);
    }

    get isInitialLogin(): boolean {
        return this._isInitialLoginSubject.value;
    }
    
    set formIsSubmitted(value: boolean) {
        this._formIsSubmittedSubject.next(value); 
    }

    get formIsSubmitted(): boolean {
        return this._formIsSubmittedSubject.value;
    }

    set formInvolvedAccidentSaved(value: boolean) {
        this._formInvolvedAccidentSaved.next(value);
    }

    get formInvolvedAccidentSaved(): boolean {
        return this._formInvolvedAccidentSaved.value;
    }

    loadDropDowns(): Observable<LookUps> {
        return this.http.get<LookUps>(`staticdata`);
    }

    getLooUpValue(name: string, id: number): string {
        const lookUp = this.lookUps!.lookUpDictionary[name];
        
        if (lookUp) {
            const item = lookUp.find(x => x.value == id);
            if (item) {
                return item.description!;
            }
        }

        return '';
    }

    navigateTo(screen: ScreenType): void {
        var screenAsString = ScreenType[screen];
        this.router.navigate(['form', screenAsString]);
    }

    getFormGroupIsPopulated(group: FormGroup): boolean {
        let fieldIsPopulated = false;

        Object.keys(group.controls).forEach(key => {
            const value = group.controls[key].value;
            if (value !== null && value !== '' && value !== undefined) {
                fieldIsPopulated = true;
            }
        });

        return fieldIsPopulated;
    }

    getFormValidationErrorsExcludeRequired(group: FormGroup): number {
        let totalErrors = 0;

        Object.keys(group.controls).forEach(key => {
            const controlErrors: ValidationErrors = group.controls[key].errors!;

            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    if (keyError != 'required') {
                        totalErrors++;
                    }
                });
            }
        });

        return totalErrors;
    }
}
